import Question from '~/components/forms/Question';
import Questions from '~/lib/Questions';

const Section = ({ section, questions, formData, setFormData }) => {
    if (questions.length === 0) {
        return null;
    }

    // Hide any questions after scheduling if we haven't yet completed scheduling
    const hideQuestions = [];
    let hideFollowingQuestions = false;
    let isFirstHiddenQuestion = true;
    for (let question of questions) {
        if (
            typeof Questions[question.type]?.hideFollowingQuestions ===
                'function' &&
            Questions[question.type]?.hideFollowingQuestions(
                question,
                formData[question.id],
            )
        ) {
            hideFollowingQuestions = true;
        } else if (hideFollowingQuestions) {
            if (isFirstHiddenQuestion && question.type === 'display') {
                // If the first hidden question is a display question
                // then we don't want to hide it
                continue;
            }

            hideQuestions.push(question.id);
            isFirstHiddenQuestion = false;
        }
    }

    return (
        <div className="mb-4">
            {questions.map(question => (
                <div key={question.id}>
                    {hideQuestions.indexOf(question.id) < 0 && (
                        <div key={question.id} className="mb-4">
                            <Question
                                isReadOnly={false}
                                question={question}
                                value={formData[question.id]}
                                setValue={value =>
                                    setFormData(question.id, value)
                                }
                                id={`answers.${question.id}`}
                            />
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default Section;
